import { range } from 'lodash';
import React, { Fragment } from 'react';

const MAX_RATING = 5;

interface FeedbackRatingProps {
  rating: number;
  containerClassName?: string;
}
const FeedbackRating = ({ rating = 0,  containerClassName}: FeedbackRatingProps) => {
  return (
    <div className={`ratings ${containerClassName}`}>
      <div className="empty-stars">
        {range(0, MAX_RATING, 1).map((item) => <Fragment key={item}>★</Fragment>)}
      </div>
      <div className="full-stars" style={{width: `${(100 * rating/5)}%`}}>
        {range(0, MAX_RATING, 1).map((item) => <Fragment key={item}>★</Fragment>)}
      </div>
    </div>
  );
};

FeedbackRating.defaultProps = {
  containerClassName: ''
};

export default FeedbackRating;
